import { z } from "zod";

export const formPlateSchema = z.object({
  plate: z
    .string()
    .trim()
    .toUpperCase()
    .min(2, "The plate must have at least 2 characters")
    .max(12, "The plate must not have more than 12 characters")
    .regex(/^[A-Z0-9]+$/, "The plate must contain only letters and numbers"),
});

export function validateLicensePlate(plate: string): string | null {
  if (!plate.trim()) {
    return "Please enter a valid license plate.";
  }
  try {
    formPlateSchema.parse({ plate });
    return null;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors[0].message;
    }
    return "Invalid plate";
  }
}
